export default __webpack_public_path__ + "static/media/arrow.d0676641.svg";